<script lang="ts" setup>
defineProps<{
  productImg?: string
  altText?: string
  rounded: boolean
}>()
</script>

<template>
  <div :class="{ 'rounded': rounded, 'fallback-bg': !productImg }" class="product__img">
    <img
      v-if="productImg"
      :alt="altText"
      :src="productImg"
      :title="altText"
      loading="lazy"
    >
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/style/helpers/include-media';

.product__img {
  display: flex;
  align-items: center;
  width: 6rem;
  height: 6rem;

  @include media('<tablet') {
    display: none;
  }

  &.rounded {
    overflow: hidden;
    margin-right: 2rem;

    @include themify($themes) {
      border-radius: rem-calc(themed('cardBorderRadius'));
    }
  }

  &.fallback-bg {
    background: radial-gradient($imageGradient);
  }

  img {
    width: 100%;
    transform: scale3d(1.15, 1.15, 1);
    object-position: center;

    .rounded & {
      object-fit: cover;
      object-position: center;
      height: 6rem;
    }
  }
}
</style>
